import { Col, Row } from 'react-styled-flexboxgrid';
import styled from 'styled-components';

import { media } from '@savgroup-front-common/constants';
import { fontStyle } from '@savgroup-front-common/core/theme/helpers/fontStyle';
import { fontWeight } from '@savgroup-front-common/primitive/helpers/fontWeight';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $OnboardingEntryFormContainer = styled(Col)`
  border-left: 1px solid ${({ theme }) => theme.colors.disabled};
  padding: ${spacing('xl')} ${spacing(12)};
`;

export const $OnboardingEntry = styled(Row)`
  height: 100%;
`;

export const $LanguageChooser = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-bottom: ${spacing(12)};
`;

export const $BackgroundCol = styled(Col)`
  padding: ${spacing('xl')} ${spacing(12)};
  background: ${({ theme }) =>
    `linear-gradient(166deg, ${theme.newUI.gradients.purpleStart} 0%, ${theme.newUI.gradients.blueEnd} 98.71%)`};
  position: relative;

  svg {
    width: ${spacing(32)};
    height: ${spacing('xl')};
  }

  img {
    margin: auto;
    display: flex;

    @media ${media.maxWidth.lg} {
      width: ${spacing(96)};
    }
    @media ${media.maxWidth.md} {
      width: ${spacing(96)};
    }
  }
`;

export const $ImgTitle = styled.div`
  font-size: ${({ theme }) => theme.tw.font.size['2xl']};
  color: ${({ theme }) => theme.colors.white};
  font-weight: ${fontWeight('bold')};
  display: flex;
  justify-content: center;
  margin-top: ${spacing(24)};
`;

export const $ImgDescription = styled.div`
  ${fontStyle('base')};
  color: ${({ theme }) => theme.colors.white};
  display: flex;
  justify-content: center;
  margin-top: ${spacing('lg')};
  margin-bottom: ${spacing(12)};
  text-align: center;
`;
